import { FileAlertIcon } from './FileAlertIcon';

/**
 * author: Simran
 * id 33050FDD-7F04-44B1-AF59-BFED56FE34CF
 * name file-alert
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-alert.svg
 * tags
 * - Files / Folders 
 * - Alert / Error 
 */
export const FileWarningIcon = FileAlertIcon;
export default FileWarningIcon